import React, { useContext, useState } from 'react';
import styled, { css } from 'styled-components';
import RadioMui from '@mui/material/Radio';

const Label = styled.label`
    width: 100%;
    height: 100%;
    padding: .5rem 1rem;
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 1rem;
    cursor: pointer;
    position: relative;
    transition: background-color .2s,color .2s;
    border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
    text-align: center;

    ${props => props.error && css`
        border-color: red;
        border-width: 5px;
    `}

    ${props => props.checked && css`
        background-color: rgba(37,59,143,.05);
        border-color: ${props => props.theme.primary};
        font-size: 16px;
    `}
`;

const InnerContent = styled.div`
    margin-left: 1rem;
`;

export default function Radio(props) {
    const { disabled, field, input, meta: { touched, error } } = props;
    const id= `${input.name}-${input.value}`;

    return (
        <Label
            checked={input.checked}
            error={touched && error}
            htmlFor={id}
        >
            <RadioMui
                disabled={disabled}
                {...input}
                id={id}
                checked={input.checked} />
            <InnerContent>
                {field.titel}
            </InnerContent>
        </Label>
    );
}

